import { render, staticRenderFns } from "./popSetting.vue?vue&type=template&id=9962c73a&"
import script from "./popSetting.vue?vue&type=script&lang=ts&"
export * from "./popSetting.vue?vue&type=script&lang=ts&"
import style0 from "./popSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports